import React, { useEffect, useState } from 'react';
import 'react-data-grid/lib/styles.css';
import { Card, CardBody, Col, Container, FormGroup, Row } from 'reactstrap';
import useFilter from '../../../hooks/useFilter';

export default function ISAAuditViewOptions() {
    const [recordGrouping, setRecordGrouping] = useState(0);
    const { filter, setFilter } = useFilter();

    useEffect(() => {
        setRecordGrouping((filter?.recordGrouping ?? 0));
    }, []);

    const onChange = (value) => {
        filter.recordGrouping = value;
        setFilter(filter);
        setRecordGrouping(value);
    };

    const detailData = [
        { id: "1", value: "College ID" },
        { id: "2", value: "Course / Assignment" },
        { id: "3", value: "Completion Date" },
        { id: "4", value: "Duration(hours)" },
        { id: "5", value: "ISA Topic" },
        { id: "6", value: "ISA Instructor" },
        { id: "7", value: "ISO Category" },
    ];

    const userData = [
        { id: "8", value: "Full Name" },
        { id: "9", value: "Personnel ID" },
    ];

    return(
        <Container>
            <h1>Report Fields</h1>
            <FormGroup>
                <Card>
                    <CardBody>
                        <Row>
                            <Col xs="6">
                                <div>Record Grouping</div>
                            </Col>
                            <Col xs="6">
                                <div>
                                    <input className='radio-margin' type='radio' name='checklistsRadio' onChange={() => onChange(0)} checked={recordGrouping === 0} /> Ungrouped
                                    <br />
                                    <input className='radio-margin' type='radio' name='checklistsRadio' onChange={() => onChange(1)} checked={recordGrouping === 1} /> Group By User
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </FormGroup>
            <FormGroup>
                <Card>
                <CardBody>    
                        <Row>
                            <Col xs="6">
                                <div>Detail Fields</div>
                            </Col>
                            <Col xs="6">
                                {detailData.map((item, index) => {
                                    return (
                                        <div key={item.id} className="checkbox-container">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="options"
                                                    value={item.value}
                                                    defaultChecked = {true}
                                                    disabled = {true}
                                                />
                                                &nbsp;{item.value}
                                            </label>
                                        </div>
                                    );
                                })}
                            </Col>
                        </Row>   
                    </CardBody>
                </Card>
            </FormGroup>
            <FormGroup>
                <Card>
                <CardBody>    
                        <Row>
                            <Col xs="6">
                                <div>User Fields</div>
                            </Col>
                            <Col xs="6">
                                {userData.map((item, index) => {
                                    return (
                                        <div key={item.id} className="checkbox-container">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    name="options"
                                                    value={item.value}
                                                    defaultChecked = {true}
                                                    disabled = {true}
                                                />
                                                &nbsp;{item.value}
                                            </label>
                                        </div>
                                    );
                                })}
                            </Col>
                        </Row>   
                    </CardBody>
                </Card>  
            </FormGroup>        
        </Container>
    );
}